import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography, Button } from "@mui/material";
import { PDFViewer } from "../../components/PDFViewer";
import { api, urls } from "../../services";
import { useToast } from "../../contexts";
import { useAuth } from "../../contexts";

export function PDFReader() {
  const { magID } = useParams();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { logout } = useAuth();
  const [pdfUrl, setPdfUrl] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get(urls.magazinePdf + magID)
      .then((res) => {
        const url = res.data.data?.pdf_url;
        if (url) {
          setPdfUrl(url);
        } else {
          setError(res.data.message || "PDF not available");
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response?.status === 401) {
          logout();
        } else {
          setError(err.response?.data?.message || "Failed to load PDF");
          showToast(err.response?.data?.message, "error");
        }
      });
  }, [magID]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <Typography variant="h6" color="text.secondary">
          {error}
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2, textTransform: "none" }}
          onClick={() => navigate(-1)}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  return <PDFViewer pdfUrl={pdfUrl} />;
}
